import React from 'react';
import { useTranslation } from 'react-i18next';

import sandwich from 'images/sandwich.svg';

interface MobileMenuProps {
  toggleMenu: () => void;
}

export default function MobileMenu({ toggleMenu }: MobileMenuProps) {
  const { t } = useTranslation(['common']);
  return (
    <div className="SiteNavigation-mobileInfo">
      <button
        type="button"
        className="SiteNavigation-mobileToggler"
        onClick={toggleMenu}
      >
        <img
          className="SiteNavigation-mobileTogglerImage SiteNavigation-mobileTogglerImage--sandwich"
          src={sandwich}
          alt={t('common:mobile_open')}
        />
        <img
          className="SiteNavigation-mobileTogglerImage SiteNavigation-mobileTogglerImage--cross"
          src={sandwich}
          alt={t('common:mobile_close')}
        />
      </button>
    </div>
  );
}
